import { useContext } from "react";

import type { FlagData } from "@/config";
import { AppContext } from "@/models/AppStateProvider";

export function useGlobalFlags(): FlagData {
  const { flags } = useContext(AppContext);
  return flags;
}
